import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { setLocale, getAvailableLocales } from '@/i18n';
import { useUserStore } from '../stores/userStore';

export const useLocale = () => {
  const { locale, t } = useI18n();
  const userStore = useUserStore();

  const currentLocale = computed(() => locale.value);

  const availableLocales = computed(() => getAvailableLocales());

  const changeLocale = (newLocale: string) => {
    setLocale(newLocale);
    userStore.setCulture(newLocale);
  };

  const getLocaleName = (localeCode: string) => {
    const localeInfo = availableLocales.value.find((l) => l.code === localeCode);
    return localeInfo?.name || localeCode;
  };

  const getLocaleFlag = (localeCode: string) => {
    const localeInfo = availableLocales.value.find((l) => l.code === localeCode);
    return localeInfo?.flag || '🌐';
  };

  return {
    currentLocale,
    availableLocales,
    changeLocale,
    getLocaleName,
    getLocaleFlag,
    t,
  };
};
